<form [formGroup]="editEmailSettingsForm">
  <h3>
    {{
    'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.EMAIL_SUBJECT_AND_SENDER'
    | translate
    }}
  </h3>
  <mat-form-field class="form-field">
    <input
      matInput
      placeholder="{{
        'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.EMAIL_SUBJECT' | translate
      }}"
      [required]="true"
      formControlName="emailSubject"
      />
  </mat-form-field>
  <mat-form-field class="form-field">
    <input
      matInput
      placeholder="{{
        'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.REPLY_TO_EMAIL' | translate
      }}"
      formControlName="sendFromAddress"
      />
    <mat-hint
      align="start"
      [matTooltip]="
        'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.REPLY_TO_TOOLTIP' | translate
      "
      >
      <a class="form-tooltip">
        {{ 'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.TOOLTIP' | translate }}
      </a>
    </mat-hint>
  </mat-form-field>
</form>

<h3>{{ 'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.EMAIL_CONTENT' | translate }}</h3>
<div class="placeholder-like-text">
  {{ 'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.HEADER' | translate }}
</div>
<div class="select-header">
  @if (emailSettings.headerUrl) {
    <div class="image-overlay">
      <div class="gradient-overlay"></div>
      <img [src]="emailSettings.headerUrl" />
      <mat-menu #headerImage>
        <button mat-menu-item (click)="selectHeaderImage()">
          {{ 'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.EDIT_HEADER' | translate }}
        </button>
        <button mat-menu-item (click)="deleteHeaderImage()">
          {{ 'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.DELETE_HEADER' | translate }}
        </button>
      </mat-menu>
      <mat-icon id="header-image-button" [matMenuTriggerFor]="headerImage">
        more_vert
      </mat-icon>
    </div>
  }
  @if (!emailSettings.headerUrl) {
    <div
      id="no-header"
      (click)="selectHeaderImage()"
      >
      <mat-icon class="mat-icon-size">add_a_photo</mat-icon>
      <div>
        {{
        'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.UPLOAD_EMAIL_HEADER' | translate
        }}
      </div>
    </div>
  }
</div>

<form [formGroup]="editEmailSettingsForm">
  <mat-form-field class="form-field">
    <input
      matInput
      placeholder="{{
        'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.EMAIL_TITLE' | translate
      }}"
      [required]="true"
      formControlName="emailTitle"
      />
  </mat-form-field>
  <mat-form-field class="form-field">
    <mat-select
      placeholder="{{
        'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.TITLE_FONT' | translate
      }}"
      formControlName="emailTitleFont"
      >
      @for (font of fonts; track font) {
        <mat-option
          [value]="font"
          [style.font-family]="font"
          >
          {{ font }}
        </mat-option>
      }
    </mat-select>
    <mat-hint align="end">
      {{
      'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.DEFAULT_FONT_HELP_TEXT'
      | translate
      }}
    </mat-hint>
  </mat-form-field>
  <mat-form-field class="form-field">
    <mat-select
      matInput
      placeholder="{{
        'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.EMAIL_GREETING' | translate
      }}"
      formControlName="emailGreeting"
      >
      @for (greeting of greetings; track greeting) {
        <mat-option [value]="greeting">
          {{ greeting }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="placeholder-like-text">
    {{ 'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.MESSAGE' | translate }}
  </div>
  <div class="tinymce-container">
    <app-rich-editor
      #messageBodyEditor
      elementId="emailBodyTinymce-{{ emailRequestType }}"
      formControlName="emailBody"
      [height]="250"
      plugins="lists advlist link code image paste"
      toolbar="bold italic underline fontsizeselect | alignleft aligncenter alignright alignjustify | undo redo | bullist numlist | link unlink removeformat | code"
    ></app-rich-editor>
  </div>
  <mat-form-field class="form-field">
    <mat-select
      placeholder="{{
        'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.GREETING_AND_MESSAGE_FONT'
          | translate
      }}"
      formControlName="emailBodyFont"
      >
      @for (font of fonts; track font) {
        <mat-option
          [value]="font"
          [style.font-family]="font"
          >
          {{ font }}
        </mat-option>
      }
    </mat-select>
    <mat-hint align="end">
      {{
      'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.DEFAULT_FONT_HELP_TEXT'
      | translate
      }}
    </mat-hint>
  </mat-form-field>
  @if (emailRequestType === 'internal') {
    <div class="button-fields">
      <mat-form-field>
        <input
          matInput
        placeholder="{{
          'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.BUTTON_TEXT' | translate
        }}"
          [required]="true"
          formControlName="buttonText"
          />
      </mat-form-field>
      <mat-form-field>
        <div class="button-color-picker">
          <div
            class="color-chip"
            [style.background-color]="emailSettings.buttonColor"
          ></div>
          <input
            [(colorPicker)]="emailSettings.buttonColor"
            (colorPickerChange)="newColor($event)"
            cpPosition="bottom"
          placeholder="{{
            'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.BUTTON_COLOR' | translate
          }}"
            matInput
            [required]="true"
            formControlName="buttonColor"
            />
        </div>
      </mat-form-field>
      <mat-form-field class="form-field">
        <input
          matInput
        placeholder="{{
          'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.BUTTON_URL' | translate
        }}"
          formControlName="buttonUrl"
          [required]="!hasMyListing"
          />
        @if (hasMyListing) {
          <mat-hint
            align="start"
        [matTooltip]="
          'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.BUTTON_URL_TOOLTIP' | translate
        "
            >
            <a (click)="(null)" class="form-tooltip">
              {{ 'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.TOOLTIP' | translate }}
            </a>
          </mat-hint>
        }
        @if (editEmailSettingsForm.get('buttonUrl').errors) {
          <mat-error
            align="end"
            >
            {{ getFormError(editEmailSettingsForm) | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  <div class="placeholder-like-text">
    {{ 'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.CLOSING_MESSAGE' | translate }}
  </div>
  <div class="tinymce-container">
    <app-rich-editor
      #secondaryMessageBodyEditor
      elementId="secondaryMessageBodyTinymce-{{ emailRequestType }}"
      formControlName="secondaryMessageBody"
      [height]="250"
      plugins="lists advlist link code image paste"
      toolbar="bold italic underline fontsizeselect | alignleft aligncenter alignright alignjustify | undo redo | bullist numlist | link unlink removeformat | code"
    ></app-rich-editor>
  </div>
  @if (emailRequestType === 'external') {
    <div>
      <mat-checkbox formControlName="includeDirectFeedbackOption" color="primary">
        {{
        'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.INCLUDE_DIRECT_FEEDBACK_OPTION'
        | translate
        }}
      </mat-checkbox>
      <div class="direct-feedback-helper-text">
        {{
        'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.DIRECT_FEEDBACK_HELPER_TEXT'
        | translate
        }}
      </div>
      <div [style.display]="directFeedbackOptionDisplay">
        <div class="placeholder-like-text">
          {{
          'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.DIRECT_FEEDBACK_MESSAGE'
          | translate
          }}
        </div>
        <div class="tinymce-container">
          <app-rich-editor
            #directFeedbackMessageEditor
            elementId="directFeedbackMessage-{{ emailRequestType }}"
            formControlName="directFeedbackMessage"
            [height]="100"
            plugins="lists advlist link code image paste"
            toolbar="bold italic underline fontsizeselect | alignleft aligncenter alignright alignjustify | undo redo | bullist numlist | link unlink removeformat | code"
          ></app-rich-editor>
        </div>
        <div class="button-fields">
          <mat-form-field>
            <input
              matInput
            placeholder="{{
              'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.BUTTON_TEXT' | translate
            }}"
              [required]="true"
              formControlName="buttonText"
              />
          </mat-form-field>
          <mat-form-field>
            <div class="button-color-picker">
              <div
                class="color-chip"
                [style.background-color]="emailSettings.buttonColor"
              ></div>
              <input
                [(colorPicker)]="emailSettings.buttonColor"
                (colorPickerChange)="newColor($event)"
                cpPosition="bottom"
              placeholder="{{
                'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.BUTTON_COLOR' | translate
              }}"
                matInput
                [required]="true"
                formControlName="buttonColor"
                />
            </div>
          </mat-form-field>
          <mat-form-field class="form-field">
            <input
              matInput
            placeholder="{{
              'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.BUTTON_URL' | translate
            }}"
              formControlName="buttonUrl"
            [required]="
              !hasMyListing &&
              editEmailSettingsForm.get('includeDirectFeedbackOption').value
            "
              />
            @if (hasMyListing) {
              <mat-hint
                align="start"
            [matTooltip]="
              'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.BUTTON_URL_TOOLTIP'
                | translate
            "
                >
                <a (click)="(null)" class="form-tooltip">
                  {{ 'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.TOOLTIP' | translate }}
                </a>
              </mat-hint>
            }
            @if (editEmailSettingsForm.get('buttonUrl').errors) {
              <mat-error
                align="end"
                >
                {{ getFormError(editEmailSettingsForm) | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
  }
</form>
<div class="placeholder-like-text">
  {{ 'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.LOGO' | translate }}
</div>
<app-image-uploader-editor
  [uploadUrl]="imageUploadUrl$ | async"
  [aspects]="aspects"
  [currentImageUrl]="emailSettings.logoUrl"
  (uploadedFile)="uploadedLogoImage($event)"
></app-image-uploader-editor>
{{ 'SETTINGS.EMAIL_SETTINGS.CONTENT_FORM.LOGO_DIMENSIONS' | translate }}
<div class="button-container">
  <app-processing-button
    [raised]="true"
    [buttonText]="'SETTINGS.SAVE_AND_PREVIEW'"
    (buttonClick)="submitEmailSettingsForm()"
    [isProcessing]="isSaving"
  ></app-processing-button>
  <button mat-button color="primary" (click)="returnSettingsToDefaults()">
    {{ 'SETTINGS.RESTORE_TO_DEFAULTS' | translate }}
  </button>
</div>
